import {on} from 'delegated-events'
import {PANEL_IDS} from './types'

// SegmentedControl toggle handler - registered at module load time
on('click', '.js-mcp-toggle-test a', function (event) {
  event.preventDefault()

  const link = event.currentTarget as HTMLAnchorElement

  // Use link.hash for safer URL fragment handling
  let panelId: string
  if (link.hash) {
    panelId = link.hash.startsWith('#') ? link.hash.slice(1) : link.hash
  } else {
    const href = link.getAttribute('href')
    if (!href) return
    panelId = href.startsWith('#') ? href.slice(1) : href
  }

  // Find the container that holds both the toggle and panels
  const container = link.closest('.js-mcp-toggle-test')
  const dialogBody = container?.closest('[data-view-component]') || container?.parentElement

  // Toggle panels - search within the dialog context
  const externalPanel = dialogBody?.querySelector<HTMLElement>(`#${PANEL_IDS.EXTERNAL}`)
  const githubPanel = dialogBody?.querySelector<HTMLElement>(`#${PANEL_IDS.GITHUB}`)

  if (externalPanel) externalPanel.hidden = panelId !== PANEL_IDS.EXTERNAL
  if (githubPanel) githubPanel.hidden = panelId !== PANEL_IDS.GITHUB

  // Update the SegmentedControl visual state
  const segmentedControl = container?.querySelector('segmented-control')
  if (segmentedControl) {
    // Remove selected state from all items
    const allItems = segmentedControl.querySelectorAll('li.SegmentedControl-item')
    for (const item of allItems) {
      item.classList.remove('SegmentedControl-item--selected')
      item.querySelector('[aria-current]')?.removeAttribute('aria-current')
    }

    // Add selected state to clicked item
    const clickedItem = link.closest('li.SegmentedControl-item')
    clickedItem?.classList.add('SegmentedControl-item--selected')
    link.setAttribute('aria-current', 'true')
  }

  // Update hidden input - only set for known panel IDs
  const input = container?.querySelector<HTMLInputElement>('.js-mcp-type-value')
  if (input) {
    if (panelId === PANEL_IDS.EXTERNAL) {
      input.value = 'external'
    } else if (panelId === PANEL_IDS.GITHUB) {
      input.value = 'github'
    }
  }
})
